import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20">
      <span className="font-heading text-7xl md:text-9xl font-black text-primary-500/25 select-none">404</span>
      <span className="mt-4 w-14 h-14 flex items-center justify-center rounded-full bg-background-100 border border-background-200 text-secondary-500">
        <i className="ri-film-line text-2xl" />
      </span>
      <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-secondary-500 max-w-md">
        你访问的页面可能已被移动或不存在：<span className="text-foreground-800">{location.pathname}</span>
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/reviews"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-100 border border-background-200 text-foreground-800 text-sm hover:border-accent-500 transition-colors whitespace-nowrap"
        >
          <i className="ri-book-open-line" />
          浏览影评
        </Link>
      </div>
    </div>
  );
}